import http from '@/utils/http'


export function getdata() {
  return http.get('/index/index/orders')
}

export function suborder(data) {
    return http.post('/index/index/suborder', data)
}

export function orderamount(data) {
    return http.post('/index/index/userinfo', data)
}

export function getorderinfo(id) {
  return http.get('/index/index/getorder?id=' + id)
}


export function payorder(id) {
  return http.post('/index/index/payment', {id: id})
}